<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1">
                <v-col sm="6" md="4" class="py-0" justify="center" align="center">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('pendings.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="6" align="end" class="py-0">                    
                    <btn-primary :label="$t('pendings.new')" :icon="'add'" @click="to_create_national" v-permission:all="'appointment.create|n_pending.create'"></btn-primary>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :pagination="[10, 20, 50, 100]" :props="{headers:headers, items: props.items, search:props.search}" :itemsLength="props.meta.total" :options.sync="pagination.pendings" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>        
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import FileSaver from 'file-saver';
import { HttpAppointmentRepository } from '../../infrastructure/appointment_repository'
import { downloadProductDetailAppointmentUseCase } from '../../application/use_cases/download_product_detail_appointment_use_case'
import { appointmentIndexUseCase } from '../../application/use_cases/appointment_index_use_case';

export default {
    computed: {
        headers(){
            //adding column operation in Spanish
            if(this.$store.state.language == 'es') return [
                { text: this.$t('pendings.id'), value: 'idIndex', class: 'text-uppercase', sortable: false },
                { text: this.$t('pendings.client'), value: 'client.name', class: 'text-uppercase' },
                { text: this.$t('pendings.date'), value: 'arrival_date', class: 'text-uppercase' },
                { text: this.$t('pendings.movement_type'), value: this.$store.state.language == 'es' ? 'operation.description_es' : 'operation.description_en', class: 'text-uppercase' },
                { text: this.$t('pendings.container'), value: 'container_number', class: 'text-uppercase' },
                { text: this.$t('pendings.description'), value: 'description', class: 'text-uppercase' },
                { text: this.$t('pendings.comments'), value: 'commentary', class: 'text-uppercase' },
                { text: this.$t('pendings.user'), value: 'user.name', class: 'text-uppercase' },
                { text: this.$t('pendings.actions'), value: 'actions', align: "center", class: 'text-uppercase' },
            ]
            //adding columnm operation in English
            else return [
                { text: this.$t('pendings.id'), value: 'idIndex', class: 'text-uppercase', sortable: false },
                { text: this.$t('pendings.client'), value: 'client.name', class: 'text-uppercase' },
                { text: this.$t('pendings.date'), value: 'arrival_date', class: 'text-uppercase' },
                { text: this.$t('pendings.movement_type'), value: this.$store.state.language == 'es' ? 'operation.description_es' : 'operation.description_en', class: 'text-uppercase' },
                { text: this.$t('pendings.container'), value: 'container_number', class: 'text-uppercase' },
                { text: this.$t('pendings.description'), value: 'description', class: 'text-uppercase' },
                { text: this.$t('pendings.comments'), value: 'commentary', class: 'text-uppercase' },
                { text: this.$t('pendings.user'), value: 'user.name', class: 'text-uppercase' },
                { text: this.$t('pendings.actions'), value: 'actions', align: "center", class: 'text-uppercase' },
            ]
        } 
    },
    data(){
        return {
            m_type: this.$route.params.m_type, // income || outcome
            items: {
                clients: []
            },
            props: {
                search: '',
                items: [],
                meta: {
                    total: 0,
                    total_pages: 0,
                    per_page: 10,
                    page: 1
                },
                sort_by: []
            },
            debounceTimer: null,
            pagination: {page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false},
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
        }
    },
    mounted(){
        if(this.m_type == "income") this.$store.state.module = "headers.n_pendings_income";
        else if(this.m_type == "outcome") this.$store.state.module = "headers.n_pendings_outcome";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            try{
                this.props.items = [];

                const res = await appointmentIndexUseCase('Pendiente', '1', this.m_type, this.props.meta.page, this.props.meta.per_page, this.props.search, null, this.props.sort_by, HttpAppointmentRepository);
                this.props.items = res.data;
                this.props.meta = res.meta;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async downloadProductDetail(id){
            try {
                const result = await downloadProductDetailAppointmentUseCase(id, HttpAppointmentRepository);

                FileSaver.saveAs(result.data.success.arguments.file, 'ProductDetailReport-appointment-' + id + '.xlsx');
            } 
            catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;
            
            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 
            
            this.index();
        },
        to_create_national() {
            this.$router.push('/create-appointment/national/' + this.m_type);
        },
    },
    watch: {
        '$route.params.m_type': function() {
            location.reload();
        },
        'props.search': async function(){
            clearTimeout(this.debounceTimer)

            this.debounceTimer = setTimeout(() => {
                this.index();
            }, 800);
        }
    }
}
</script>

<style lang="scss">

</style>